/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Staff_MenuInputs */



/**
* | output |
* | --- |
* | "Support" |
*
* @param {Meeting_Staff_MenuInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_staff_menu = /** @type {((inputs?: Meeting_Staff_MenuInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Staff_MenuInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Support")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Support")
	return /** @type {LocalizedString} */ ("Support")
});